import React, { Component } from 'react'
// import Settings from '../settings'
import ReactHtmlParser from 'react-html-parser'

// This component has:
// 1. Page title
// 2. Subtitle
// 3. Orb animations

// Import animation library
import { TimelineMax } from 'TweenMax'
// import ScrollMagic from 'scrollmagic'
import 'animation.gsap'
import 'debug.addIndicators'

import IconSquare from './icons/IconSquare'

class Header extends Component {

   componentWillMount() {
    // Setup object id, and a place to store animations
    this.section = 'Header'
   }

   componentDidMount() {
     this.animateEnter()
   }

   animateEnter = () => {
      const tl = new TimelineMax()

      // let elements = document.getElementsByClassName('.h1-top')
      tl.from('.page-title, .site-title', 0.4, {
         css: {
          opacity: 0
         },
        //  ease: Sine.easeInOut
      }, 0.47)

      return tl
   }

   render() {
      const {
        title = 'That Day Now',
        title_japanese = 'あの日<div class="inline-block header-title-japanese-kern-small">、</div>今',
      //   subtitle = 'Keiko Ogura 小倉桂子',
      } = this.props.data

      const page_title = this.props.page.title.rendered

      return (
         <div className="HeaderPage">

            <div className="page-width">
              <a className="header-title-single-page-a" href="/"><h2 className="site-title orange header-title-single-page"> <div className="dib"><IconSquare size="30px" />&nbsp;&nbsp;</div>{title}<div className="dib">&nbsp;&nbsp;&nbsp;</div><div className="dib">{ReactHtmlParser(title_japanese)}</div><div className="dib">&nbsp;&nbsp;<IconSquare size="30px" /></div></h2></a>
              <h1 className="page-title">{page_title}</h1>
            </div>

         </div>
      )
   }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/HeaderPage.js